<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions="6000202">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="manualPaymentBO.ajax?cmd=queryPayOut"
          :params="fullSearchData"
          bizName="支付结果数据导出"
          bizCode="exp100041"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>

      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="scope.column.property === 'busiCode'">
                  <template v-if="checkPermpisions('6000204')">
                    <span class="primary cur" @click="toOrderDetail(scope.row)">
                      {{ scope.row[scope.column.property] }}
                    </span>
                  </template>
                  <template v-else>
                     <span>
                      {{ scope.row[scope.column.property] }}
                    </span>
                  </template>
                </section>
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  payResultList,
} from 'api/getPay';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'flowId', label: '支付流水号', fixed: true },
          { prop: 'payBankAccName', label: '付款账户名' },
          { prop: 'payBankAccNo', label: '付款账号' },
          { prop: 'userName', label: '业务方' },
          { prop: 'accName', label: '收款账户名' },
          { prop: 'accNo', label: '收款账号' },
          { prop: 'orgName', label: '归属部门' },
          { prop: 'plateNumber', label: '车牌号' },
          { prop: 'busiCode', label: '业务单号' },
          { prop: 'dependTime', label: '要求发车时间' },
          { prop: 'customName', label: '客户名称' },
          { prop: 'sourceName', label: '线路名称' },
          { prop: 'collectionUserName', label: '代收名称' },
          { prop: 'orderRemark', label: '订单备注' },
          { prop: 'busiIdName', label: '业务类型' },
          { prop: 'isNeedBillName', label: '票据类型' },
          { prop: 'txnAmtDouble', label: '业务金额' },
          { prop: 'billServiceFeeDouble', label: '票据服务费' },
          { prop: 'appendFreightDouble', label: '附加运费' },
          { prop: 'sumTxnFeeDouble', label: '支付总金额' },
          { prop: 'payTime', label: '发起支付时间' },
          { prop: 'respCodeName', label: '状态' },
          { prop: 'respMsg', label: '备注' },
          { prop: 'completeTime', label: '付款完成时间' },
          { prop: 'accNameAndAccNo', label: '代付收款人' },
          { prop: 'respCodeName100', label: '代付状态' },
          { prop: 'payTime100', label: '代付完成时间' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: payResultList,
    toOrderDetail (item) {
      switch (item.subjectsId) {
        // case 2302: // ETC
        //   break;
        case 1443: // 司机报销
        case 1445: // 车管报销
        case 1800: // 服务费
        case 50070: // 违章
        case 1674: // 北斗缴费
        case 1131: // 油费充值（流水）
        case 4020: // 轮胎租赁
          break;
        case 1653: // 邮费
        case 1657: // 维修
          this.jump({
            label: '交易记录',
            url: `/manage/service/site/transRecord?orderId=${item.busiCode}`,
            full: true,
          });
          break;
        case 1626: // 开票申请
        case 1640:
          this.jump({
            label: '申请记录',
            url: '/manage/operate/invoice/record',
            full: true,
          });
          break;
        case 1732: // 供应商油卡充值
          this.jump({
            label: '交易记录',
            url: `/manage/cost/car/apply?applyCode=${item.busiCode}`,
          });
          break;
        // case 1851: // 新车购置
        //   break;
        case 1441: // 车管借支
        case 1431: // 司机借支
          this.jump({
            label: '司机借支详情',
            url: `/manage/cost/borrow/driver/detail?id=${item.busiCode}`,
            full: true,
          });
          break;
        case 1816: // 管理费申请
          this.jump({
            label: '管理费用详情',
            url: `/manage/cost/manage?busiCode=${item.busiCode}`,
            full: true,
          });
          break;
        case 1728: // 车辆费用申请
        case 1832:
          this.jump({
            label: '车辆费用详情',
            url: `/manage/cost/car/car?busiCode=${item.busiCode}`,
            full: true,
          });
          break;
        case 1630: // 供应商油卡充值
          this.jump({
            label: '油卡充值核销',
            url: `/manage/service/oil/recharge?busiCode=${item.busiCode}`,
          });
          break;
        case 4013: // 维保管理
          this.jump({
            label: '维保申请详情',
            url: `/manage/cost/car/apply/maintenanceDetail?id=${item.busiCode}`,
            full: true,
          });
          break;
        default: // 订单详情 1530 || 1651 || 1532 || 1536 || 1614 || 1577
          // 1611 || 1655 || 1632 || 1639 || 1644 || 1643 || 1647 || 1662 || 1561 || 1563
          this.jump({
            label: `订单详情-${item.busiCode}`,
            url: `/manage/operate/order/deal/orderDetailTab?id=${item.busiCode}`,
            full: true,
          });
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
